import { render, staticRenderFns } from "./AgendamentoEnvioMensagemCanalSelect.vue?vue&type=template&id=037b61d2&"
import script from "./AgendamentoEnvioMensagemCanalSelect.vue?vue&type=script&lang=js&"
export * from "./AgendamentoEnvioMensagemCanalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VExpandTransition,VRow,VSelect})
